import { ObjectSchema } from "yup";

import {
  RichLogCommaMode,
  RichLogLevel,
  RichLogSorting,
  yupLocalized,
} from "@ryde/shared";

export interface IExportLogsCsvData {
  [key: string]: string;
}

export const RICH_LOGS_PAGE_SIZE = 50;

export const RichLogAiHintMode = {
  All: "all",
  OnlyWithInfo: "onlyWithInfo",
  HideInfo: "hideInfo",
} as const;

export type TRichLogAiHintMode =
  (typeof RichLogAiHintMode)[keyof typeof RichLogAiHintMode];

export interface IRichLogsFilter {
  levels?: RichLogLevel[];
  searchText?: string;
  group?: number;
  commaMode?: RichLogCommaMode;
  step?: string;
  sort?: RichLogSorting;
  page?: number;
  showDebugInfo?: boolean;
  withAiHintsOnly?: boolean;
  aiHintMode?: TRichLogAiHintMode;
}

export const richLogInitialModel: IRichLogsFilter = {
  searchText: "",
  levels: [
    RichLogLevel.Critical,
    RichLogLevel.Error,
    RichLogLevel.Warn,
    RichLogLevel.Info,
  ],
  group: undefined,
  commaMode: RichLogCommaMode.Or,
  step: undefined,
  sort: RichLogSorting.ByTimeAscending,
  page: 1,
  showDebugInfo: false,
  withAiHintsOnly: false,
  aiHintMode: RichLogAiHintMode.All,
};

export const RichLogFormFields = {
  levels: "levels",
  searchText: "searchText",
  group: "group",
  commaMode: "commaMode",
  step: "step",
  sort: "sort",
  page: "page",
  showDebugInfo: "showDebugInfo",
  withAiHintsOnly: "withAiHintsOnly",
  aiHintMode: "aiHintMode",
} as const satisfies Record<keyof IRichLogsFilter, string>;

export const richLogValidationSchema: ObjectSchema<IRichLogsFilter> =
  yupLocalized
    .object()
    .shape({
      levels: yupLocalized
        .array()
        .of(yupLocalized.string().oneOf(Object.values(RichLogLevel)))
        .transform(value => (Array.isArray(value) ? value : undefined))
        .optional(),
      searchText: yupLocalized.string().optional().nullable(),
      group: yupLocalized.number().optional().nullable(),
      commaMode: yupLocalized
        .string()
        .oneOf(Object.values(RichLogCommaMode))
        .optional(),
      step: yupLocalized.string().optional().nullable(),
      sort: yupLocalized
        .string()
        .oneOf(Object.values(RichLogSorting))
        .optional(),
      page: yupLocalized.number().min(1).optional(),
      showDebugInfo: yupLocalized.boolean().optional(),
      withAiHintsOnly: yupLocalized.boolean().optional(),
      aiHintMode: yupLocalized
        .string()
        .oneOf(Object.values(RichLogAiHintMode))
        .optional(),
    })
    .noUnknown() as ObjectSchema<IRichLogsFilter>;
